/**
 * @param {string} hex - The base hex color to be darkened.
 * @param {number} [alpha=0.32] - The opacity of the overlay color.
 * @returns {string} - The resulting hex color after blending.
 */
export const getAdjustedColor = (hex, alpha = 0.32) => {
	const luminance = getLuminance(hex);

	const isLowLuminance = luminance < 64;

	const overlay = isLowLuminance ? [255, 255, 255] : [16, 16, 16];

	return adjustWithOverlay(hex, isLowLuminance ? alpha * 1.5 : alpha, overlay);
};

/** @param {string} hex */
export const getLuminance = (hex) => {
	const [r, g, b] = hexToRgb(hex);
	return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/** @param {string} hex
 * @returns {boolean}
 */
export const isVisibleOnWhite = (hex) => {
	const luminance = getLuminance(hex);

	return luminance < 240;
};

/**
 * @param {string} hex - The base hex color to be darkened.
 * @param {number} [alpha=0.32] - The opacity of the overlay color.
 * @param {number[]} overlay - The RGB values of the overlay color.
 * @returns {string} - The resulting hex color after blending.
 */
const adjustWithOverlay = (hex, alpha = 0.32, overlay) => {
	const [r1, g1, b1] = hexToRgb(hex);
	const [r2, g2, b2] = overlay;

	const r = Math.round(r2 * alpha + r1 * (1 - alpha));
	const g = Math.round(g2 * alpha + g1 * (1 - alpha));
	const b = Math.round(b2 * alpha + b1 * (1 - alpha));

	return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
};

/**
 * @param {string} h - The hex color string (e.g., "#01bfd1" or "#0f0").
 * @returns {number[]} - An array containing the red, green, and blue values as integers.
 */
const hexToRgb = (h) => {
	h = h.replace('#', '');
	if (h.length === 3) {
		h = h
			.split('')
			.map((x) => x + x)
			.join('');
	}
	return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};
